import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const pushSupported = () =>
  "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;

const urlBase64ToUint8Array = (base64String) => {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = window.atob(base64);
  return Uint8Array.from([...raw].map((c) => c.charCodeAt(0)));
};

export const getRegistration = async () => navigator.serviceWorker.register("/push-sw.js");

export const getExistingSubscription = async () => {
  if (!pushSupported()) return null;
  const reg = await getRegistration();
  return reg.pushManager.getSubscription();
};

export const subscribeToPush = async () => {
  const permission = await Notification.requestPermission();
  if (permission !== "granted") throw new Error("Notifications were blocked. Enable them in your browser settings.");
  const reg = await getRegistration();
  const { data } = await axios.get(`${API}/push/public-key`);
  const sub = await reg.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: urlBase64ToUint8Array(data.public_key),
  });
  const json = sub.toJSON();
  await axios.post(`${API}/push/subscribe`, { endpoint: json.endpoint, keys: json.keys }, { withCredentials: true });
  return sub;
};

export const unsubscribeFromPush = async () => {
  const sub = await getExistingSubscription();
  if (sub) {
    await axios.post(`${API}/push/unsubscribe`, { endpoint: sub.endpoint }, { withCredentials: true }).catch(() => {});
    await sub.unsubscribe();
  }
};

export const sendTestPush = async () => {
  const { data } = await axios.post(`${API}/push/test`, {}, { withCredentials: true });
  return data;
};
